<template>
  <div class="share-button-container" :class="theme" @click.stop="emit('click')">
    <div class="share-button-base"></div>
    <div class="share-button-border"></div>
    <div class="share-button-inner"></div>
    <div class="share-button-text">{{ text }}</div>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['click']);

defineProps<{
  text: string;
  theme: 'light' | 'dark';
}>();
</script>

<style lang="scss" scoped>
.share-button-base {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.share-button-border {
  position: absolute;
  width: 100%;
  height: 100%;
  border-width: 1px 0px;
  border-style: solid;
  border-color: #fefdf8;
  border-radius: 50px;
}

.share-button-inner {
  position: absolute;
  width: calc(100% - 24px);
  height: 100%;
  border-width: 1px 0px;
  border-style: solid;
  border-color: #fefdf8;
  border-radius: 50px;
}

.share-button-text {
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 14px;
  font-family: XiangCuiKeSong;
  color: #824728;
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-button-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 146px;
  height: 34px;

  &.light {
    .share-button-base {
      background: rgba(226, 209, 153, 0.7);
      filter: blur(2.5px);
    }

    .share-button-border,
    .share-button-inner {
      filter: blur(0.75px);
    }

    .share-button-text {
      color: #824728;
    }
  }

  &.dark {
    .share-button-base {
      background: rgba(226, 209, 153, 0.14);
      filter: none;
    }

    .share-button-border,
    .share-button-inner {
      filter: none;
    }

    .share-button-text {
      color: #edd9bb;
    }
  }
}
</style>
